(function () {
  if (window.mahzarishHeaderCountBadges) return;

  const MAX_BADGE_COUNT = 99;
  const WISHLIST_KEY = 'wishlist';

  const formatCount = (count) => (count > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : String(count));

  const setBadges = (selector, count) => {
    const normalizedCount = Number.isFinite(Number(count)) ? Math.max(0, Number(count)) : 0;

    document.querySelectorAll(selector).forEach((badge) => {
      badge.textContent = formatCount(normalizedCount);
      badge.hidden = normalizedCount === 0;
      badge.classList.toggle('is-hidden', normalizedCount === 0);
    });
  };

  const getWishlistCount = () => {
    try {
      const wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');

      if (Array.isArray(wishlist)) return wishlist.length;
      if (wishlist && typeof wishlist === 'object') return Object.keys(wishlist).length;
    } catch (_) {
      return 0;
    }

    return 0;
  };

  const updateWishlistBadges = () => {
    setBadges('[data-wishlist-count-badge]', getWishlistCount());
  };

  const updateCartBadges = (count) => {
    setBadges('[data-cart-count-badge]', count);
  };

  const fetchCartCount = async () => {
    if (!document.querySelector('[data-cart-count-badge]')) return;

    try {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json',
        },
        cache: 'no-store',
      });
      const cart = await response.json();

      updateCartBadges(cart.item_count || 0);
    } catch (_) {
      // Keep the server-rendered count if the cart endpoint is unavailable.
    }
  };

  const updateAllBadges = () => {
    updateWishlistBadges();
    fetchCartCount();
  };

  const queueWishlistUpdate = () => {
    window.requestAnimationFrame(updateWishlistBadges);
  };

  const patchWishlistStorageUpdates = () => {
    const storagePrototype = window.Storage && window.Storage.prototype;

    if (!storagePrototype || storagePrototype.__mahzarishWishlistBadgePatched) return;

    const setItem = storagePrototype.setItem;
    const removeItem = storagePrototype.removeItem;
    const clear = storagePrototype.clear;

    storagePrototype.setItem = function (key) {
      const result = setItem.apply(this, arguments);
      if (this === localStorage && key === WISHLIST_KEY) queueWishlistUpdate();
      return result;
    };

    storagePrototype.removeItem = function (key) {
      const result = removeItem.apply(this, arguments);
      if (this === localStorage && key === WISHLIST_KEY) queueWishlistUpdate();
      return result;
    };

    storagePrototype.clear = function () {
      const result = clear.apply(this, arguments);
      if (this === localStorage) queueWishlistUpdate();
      return result;
    };

    Object.defineProperty(storagePrototype, '__mahzarishWishlistBadgePatched', {
      value: true,
    });
  };

  try {
    patchWishlistStorageUpdates();
  } catch (_) {
    // Storage can be restricted in some browser privacy modes; badges still update on page load.
  }

  document.addEventListener('DOMContentLoaded', updateAllBadges);
  window.addEventListener('pageshow', updateAllBadges);
  window.addEventListener('storage', (event) => {
    if (!event.key || event.key === WISHLIST_KEY) updateWishlistBadges();
  });
  document.addEventListener('wishlist:update', updateWishlistBadges);
  document.addEventListener('wishlist:updated', updateWishlistBadges);
  document.addEventListener('cart:update', fetchCartCount);

  window.mahzarishHeaderCountBadges = {
    update: updateAllBadges,
    updateWishlist: updateWishlistBadges,
    updateCart: fetchCartCount,
  };

  updateAllBadges();
})();
